export default __webpack_public_path__ + "static/media/downloads_new.212cf446.svg";